<div class="flex flex-col px-6 py-7">
  <div class="flex items-center justify-between mb-6">
    <p class="text-2xl font-bold text-sigecom-dark-gray">Parametrização do Esporte</p>

  </div>
  <sigecom-total-records-list [label]="'Esportes'" />
  <ng-container *ngIf="sportsPage && sportsPage.content?.length; else empty">
    <sigecom-list-container>
      <sigecom-list-item *ngFor="let item of sportsPage.content;">
        <div class="flex items-center justify-between">
          <div class="flex flex-col gap-2">
            <sigecom-list-title [text]="item.espTxDescricao!" />

          </div>

          <sigecom-menu-bar>
            <sigecom-menu-bar-item title="Editar" icon="pen" color="sigecom-info"
              (clickAction)="navigateToEdit(item)" />
            <!-- <sigecom-menu-bar-item title="Excluir" icon="trash" color="sigecom-danger" /> -->
          </sigecom-menu-bar>
        </div>
      </sigecom-list-item>
    </sigecom-list-container>

    <sigecom-pagination-list *ngIf="sportsPage.content?.length" class="mt-7" [totalPages]="sportsPage.totalPages!"
      [maxDisplayedPages]="10" (pageChange)="onPageChange($event)" />
  </ng-container>
  <ng-template #empty>
    <sigecom-not-found-message-list message="Nenhum esporte encontrado" />
  </ng-template>


</div>